
import Gift from "../../../assets/filled/Gift.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GiftIcon({ className, dataTestid = "GiftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Gift data-testid={dataTestid} className={classes} {...rest} />
  );
}
